import { render, staticRenderFns } from "./ModalDeleteFolder.vue?vue&type=template&id=e209f8d4&"
import script from "./ModalDeleteFolder.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports